// User object that is shared publicly

import { makeObservable } from 'mobx'
import type { MobxDocument } from '../firestore-mobx'
import {
  ObservableModelWithDecorators,
  emptyCollection,
  emptyModel,
} from '../firestore-mobx/model'
import {
  empty,
  type FirestoreRoomStateRubricResult,
} from '../firestore/RoomStateRubricResult'
import type { FirebaseRepository } from './FirebaseRepository'
import { RubricType } from '../types'

export class RoomStateRubricResult extends ObservableModelWithDecorators<FirestoreRoomStateRubricResult> {
  static empty(repository: FirebaseRepository) {
    return emptyModel(repository, this, empty)
  }

  static emptyCollection(repository: FirebaseRepository) {
    return emptyCollection(repository, this, empty)
  }

  constructor(
    repository: FirebaseRepository,
    doc: MobxDocument<FirestoreRoomStateRubricResult>
  ) {
    super(repository, doc)

    makeObservable(this)
  }

  get rubricId() {
    return this.id
  }

  /**
   * Returns the appropriate justification string for display.
   * - No transcript data (any rubric type) → i18n no-transcript copy
   * - Blooms score 0 with transcript → i18n "Participant did not discuss"
   * - All other cases → server-provided justification
   */
  justificationForRubricType(
    rubricType: RubricType,
    t: (key: string) => string
  ) {
    if (this.data.noTranscriptData)
      return t('instructor_assignment.blooms_no_transcript')
    if (rubricType === RubricType.blooms && this.data.score === 0)
      return t('instructor_assignment.blooms_empty_evaluation')
    return this.data.justification
  }

  score() {
    return this.data.score
  }
}
